<template>
  <button
    v-if="flat"
    type="button"
    class="flex w-full cursor-pointer justify-center rounded-md border border-transparent text-sm font-medium focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:opacity-75 focus:dark:ring-primary-dark-500"
    :class="{
      'text-primary-500 hover:enabled:bg-yapgray-300 dark:text-primary-dark-200 dark:hover:enabled:bg-yapgray-800 dark:hover:enabled:text-primary-dark-400':
        !buttonStyle || buttonStyle === ButtonStyle.Info,
      'text-yapred-500 dark:text-yapred-400': buttonStyle === ButtonStyle.Danger,
      'text-yapgray-900 hover:bg-yapgray-200/80 dark:text-yapgray-100 dark:hover:bg-yapgray-800':
        buttonStyle === ButtonStyle.Plain,
      'px-4 py-4': !buttonSize || buttonSize === ButtonSize.Large,
      'px-2.5 py-3': buttonSize === ButtonSize.Medium,
      'px-2 py-1.5': buttonSize === ButtonSize.Small,
      'cursor-default opacity-50': disabled
    }"
    :disabled="disabled"
  >
    <YapLoader :size="YapLoaderSizes.Small" class="mr-4" v-if="loading" />
    <slot />
  </button>
  <button
    v-else-if="outlined"
    type="button"
    class="flex w-full justify-center rounded-md border-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 active:cursor-pointer focus:dark:ring-primary-dark-500"
    :class="{
      'hover:border-yapgray-700 dark:border-yapgray-500 dark:text-yapgray-200 dark:hover:border-yapgray-200':
        !buttonStyle,
      'border-yapred-500 text-yapred-500 hover:enabled:bg-yapred-500 hover:enabled:text-yapred-50 dark:text-yapred-300':
        buttonStyle === ButtonStyle.Danger,
      'border-primary-500 text-primary-500 hover:enabled:bg-primary-500 hover:enabled:text-primary-50 active:hover:enabled:bg-primary-700 dark:border-primary-dark-400 dark:text-primary-dark-300 hover:enabled:dark:bg-primary-dark-500 hover:enabled:dark:text-primary-dark-50 active:hover:enabled:dark:bg-primary-dark-700':
        buttonStyle === ButtonStyle.Info,
      'cursor-default opacity-50': disabled,
      'px-4 py-4': !buttonSize || buttonSize === ButtonSize.Large,
      'px-2.5 py-3': buttonSize === ButtonSize.Medium,
      'px-2 py-1.5': buttonSize === ButtonSize.Small
    }"
    :disabled="disabled"
  >
    <YapLoader :size="YapLoaderSizes.Small" class="mr-4 text-white" v-if="loading" />
    <slot />
  </button>
  <button
    v-else
    type="button"
    class="flex h-fit w-full justify-center rounded-md border border-transparent text-sm font-medium"
    :class="{
      'bg-yapred-500 text-white enabled:hover:bg-yapred-700 dark:bg-yapred-400': buttonStyle === ButtonStyle.Danger,
      'bg-primary-500 text-white enabled:hover:bg-primary-700 dark:bg-primary-dark-600 dark:hover:bg-primary-dark-700':
        !buttonStyle || buttonStyle === ButtonStyle.Info,
      'cursor-default opacity-50': disabled,
      'cursor-pointer': !disabled,
      'px-4 py-4': !buttonSize || buttonSize === ButtonSize.Large,
      'px-2.5 py-3': buttonSize === ButtonSize.Medium,
      'px-2 py-1.5': buttonSize === ButtonSize.Small
    }"
    :disabled="disabled"
  >
    <YapLoader :size="YapLoaderSizes.Small" class="mr-4 text-white" v-if="loading" />
    <slot />
  </button>
</template>

<script lang="ts">
export enum ButtonStyle {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger',
  Plain = 'plain'
}
export enum ButtonSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large'
}
</script>

<script setup lang="ts">
import YapLoader, { YapLoaderSizes } from '@/components/YapLoader.vue';

const props = defineProps<{
  buttonStyle?: ButtonStyle;
  buttonSize?: ButtonSize;
  flat?: boolean;
  outlined?: boolean;
  loading?: boolean;
  disabled?: boolean;
}>();
</script>
